var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "changeReviewModal",
        "data-backdrop": "static",
        role: "dialog",
        tabindex: "-1",
      },
    },
    [
      _c(
        "b-toast",
        {
          attrs: {
            id: "toast-error",
            "auto-hide-delay": "20000",
            "no-close-button": "",
            toaster: "b-toaster-bottom-center",
          },
        },
        [
          _vm.succesChangeReview.items
            ? _c(
                "div",
                {
                  staticClass: "toast-align",
                },
                [
                  _vm._l(_vm.succesChangeReview.items, function (items, index) {
                    return _c(
                      "span",
                      {
                        key: index,
                      },
                      [_vm._v(" " + _vm._s(items.error) + " ")]
                    )
                  }),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary",
                      on: {
                        click: function ($event) {
                          return _vm.hideToast()
                        },
                      },
                    },
                    [_vm._v(" Dismiss ")]
                  ),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          attrs: {
            role: "document",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-content",
            },
            [
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass: "modal-body",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "container",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "row",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-12",
                            },
                            [
                              _vm.data &&
                              _vm.keyIdFromChangeMtp ===
                                _vm.MtpStatus.REVIEWED.toString()
                                ? _c("p", [
                                    _vm._v(
                                      ' To update the budget request to "' +
                                        _vm._s(
                                          _vm.data.constants.mtpStatus[
                                            _vm.keyIdFromChangeMtp
                                          ].name
                                        ) +
                                        '", the request must be reviewed with all flags being removed. '
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn",
                              staticStyle: {
                                color: "#0078dc",
                                "padding-bottom": "10px",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.goToDetails()
                                },
                              },
                            },
                            [_vm._v(" View details ")]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "row",
                        },
                        [
                          _vm.data && _vm.keyIdFromChangeMtp !== null
                            ? _c(
                                "div",
                                {
                                  staticClass: "col-sm-6 pb-4",
                                },
                                [
                                  _c("label", [_vm._v("Main Flag")]),
                                  _c("multiselect", {
                                    attrs: {
                                      "allow-empty": true,
                                      max: 1,
                                      multiple: true,
                                      options: _vm.flagsArray,
                                      searchable: false,
                                      "show-labels": false,
                                      label: "title",
                                      placeholder: "No flag selected",
                                      "track-by": "title",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.mainFlagChanged()
                                      },
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "singleLabel",
                                          fn: function (props) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(props.option.title) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "option",
                                          fn: function (props) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(props.option.title) +
                                                  " "
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3473667830
                                    ),
                                    model: {
                                      value: _vm.selectedMainFlag,
                                      callback: function ($$v) {
                                        _vm.selectedMainFlag = $$v
                                      },
                                      expression: "selectedMainFlag",
                                    },
                                  }),
                                  _vm.selectedMainFlag.length !== 0 &&
                                  (_vm.isYellowFlagged || _vm.isRedFlagged)
                                    ? [
                                        _c(
                                          "label",
                                          {
                                            staticClass: "checkbox-flag",
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.isYellowFlagged,
                                                  expression: "isYellowFlagged",
                                                },
                                              ],
                                              attrs: {
                                                name: _vm.isYellowFlagged,
                                                type: "checkbox",
                                                disabled: "",
                                              },
                                              domProps: {
                                                value: _vm.isYellowFlagged,
                                                checked: Array.isArray(
                                                  _vm.isYellowFlagged
                                                )
                                                  ? _vm._i(
                                                      _vm.isYellowFlagged,
                                                      _vm.isYellowFlagged
                                                    ) > -1
                                                  : _vm.isYellowFlagged,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a = _vm.isYellowFlagged,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v =
                                                        _vm.isYellowFlagged,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.isYellowFlagged =
                                                          $$a.concat([$$v]))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.isYellowFlagged =
                                                          $$a
                                                            .slice(0, $$i)
                                                            .concat(
                                                              $$a.slice($$i + 1)
                                                            ))
                                                    }
                                                  } else {
                                                    _vm.isYellowFlagged = $$c
                                                  }
                                                },
                                              },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "pl-2",
                                              },
                                              [_vm._v("Yellow Flag")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "wrapper-icon",
                                                attrs: {
                                                  id: "tooltip-target-yellow-flag",
                                                },
                                              },
                                              [
                                                _c("icon", {
                                                  staticClass: "icon-info",
                                                  attrs: {
                                                    name: "info",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-tooltip",
                                              {
                                                attrs: {
                                                  "custom-class":
                                                    "my-tooltip-class",
                                                  target:
                                                    "tooltip-target-yellow-flag",
                                                  triggers: "hover",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass:
                                                        "tooltip-white-text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Yellow Flagged Projects:"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " are projects for which the current year's budget will be reserved. These projects have a nearly finalized scope, essential data is largely available, but some details are outstanding. They have a clear and favourable business case. “Protective flagged projects fall under this category, indicating that while the framework is established, some minor details may still be pending” "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "label",
                                          {
                                            staticClass: "checkbox-flag pl-3",
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.isRedFlagged,
                                                  expression: "isRedFlagged",
                                                },
                                              ],
                                              attrs: {
                                                name: _vm.isRedFlagged,
                                                type: "checkbox",
                                                disabled: "",
                                              },
                                              domProps: {
                                                value: _vm.isRedFlagged,
                                                checked: Array.isArray(
                                                  _vm.isRedFlagged
                                                )
                                                  ? _vm._i(
                                                      _vm.isRedFlagged,
                                                      _vm.isRedFlagged
                                                    ) > -1
                                                  : _vm.isRedFlagged,
                                              },
                                              on: {
                                                change: function ($event) {
                                                  var $$a = _vm.isRedFlagged,
                                                    $$el = $event.target,
                                                    $$c = $$el.checked
                                                      ? true
                                                      : false
                                                  if (Array.isArray($$a)) {
                                                    var $$v = _vm.isRedFlagged,
                                                      $$i = _vm._i($$a, $$v)
                                                    if ($$el.checked) {
                                                      $$i < 0 &&
                                                        (_vm.isRedFlagged =
                                                          $$a.concat([$$v]))
                                                    } else {
                                                      $$i > -1 &&
                                                        (_vm.isRedFlagged = $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          ))
                                                    }
                                                  } else {
                                                    _vm.isRedFlagged = $$c
                                                  }
                                                },
                                              },
                                            }),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "pl-2",
                                              },
                                              [_vm._v("Red Flag")]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "wrapper-icon",
                                                attrs: {
                                                  id: "tooltip-target-red-flag",
                                                },
                                              },
                                              [
                                                _c("icon", {
                                                  staticClass: "icon-info",
                                                  attrs: {
                                                    name: "info",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-tooltip",
                                              {
                                                attrs: {
                                                  "custom-class":
                                                    "my-tooltip-class",
                                                  target:
                                                    "tooltip-target-red-flag",
                                                  triggers: "hover",
                                                },
                                              },
                                              [
                                                _c("div", [
                                                  _c(
                                                    "b",
                                                    {
                                                      staticClass:
                                                        "tooltip-white-text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Red Flagged Projects:"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " are projects for which will be excluded from the MTP. These projects have an unclear scope, the business case is unclear, and/or there is no valid risk or maintenance entry. The cost risk and opportunities are below the funding threshold. "
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "col-sm-6 pb-4",
                            },
                            [
                              _c("label", [_vm._v("Other Flags")]),
                              _c("multiselect", {
                                attrs: {
                                  "close-on-select": false,
                                  disabled: _vm.validateMainFlag,
                                  multiple: true,
                                  options: _vm.otherFlagsArray,
                                  searchable: false,
                                  "show-labels": false,
                                  label: "title",
                                  placeholder: "No flag(s) selected",
                                  "track-by": "title",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.disableFromFlags()
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "singleLabel",
                                    fn: function (props) {
                                      return [
                                        _vm._v(
                                          " " + _vm._s(props.option.title) + " "
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "option",
                                    fn: function (props) {
                                      return [
                                        _vm._v(
                                          " " + _vm._s(props.option.title) + " "
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                                model: {
                                  value: _vm.selectedOtherFlags,
                                  callback: function ($$v) {
                                    _vm.selectedOtherFlags = $$v
                                  },
                                  expression: "selectedOtherFlags",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "col-12 pb-4",
                            },
                            [
                              _c("label", [_vm._v("Comment")]),
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.reviewBudgetRequest.comment.text,
                                    expression:
                                      "reviewBudgetRequest.comment.text",
                                  },
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  placeholder: "Please enter a comment",
                                },
                                domProps: {
                                  value: _vm.reviewBudgetRequest.comment.text,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.reviewBudgetRequest.comment,
                                      "text",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "modal-footer",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary",
                      attrs: {
                        "data-dismiss": "modal",
                        type: "button",
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        disabled: _vm.updateDisabled,
                        type: "button",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.updateMtpStatus()
                        },
                      },
                    },
                    [_vm._v(" Update ")]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h

    return _c(
      "div",
      {
        staticClass: "modal-header",
      },
      [
        _c(
          "div",
          {
            staticClass: "container",
          },
          [
            _c(
              "div",
              {
                staticClass: "row",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "col-12",
                  },
                  [
                    _c(
                      "h5",
                      {
                        staticClass: "modal-title",
                        attrs: {
                          id: "exampleModalLabel",
                        },
                      },
                      [_vm._v(" Update MTP status ")]
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              "aria-label": "Close",
              "data-dismiss": "modal",
              type: "button",
            },
          },
          [
            _c(
              "span",
              {
                attrs: {
                  "aria-hidden": "true",
                },
              },
              [_vm._v("×")]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }